import phpMyadmin from "../../assets/BDD/phpMyAdmin.png";
import sqlite from "../../assets/BDD/SQLite.png";
import postresql from "../../assets/BDD/PostgreSQL.png";
import h2 from "../../assets/BDD/H2.png";
import mariadb from "../../assets/BDD/MariaDB.png";
const BddElements = [
  {
    id: 1,
    path: phpMyadmin,
    title: "PhpMyAdmin",
    style: "shadow-blue-500",
  },
  {
    id: 2,
    path: sqlite,
    title: "SQLite",
    style: "shadow-blue-500",
  },
  {
    id: 3,
    path: postresql,
    title: "PostgreSQL",
    style: "shadow-blue-500",
  },
  {
    id: 4,
    path: h2,
    title: "H2",
    style: "shadow-blue-500",
  },
  {
    id: 5,
    path: mariadb,
    title: "MariaDB",
    style: "shadow-blue-500",
  },
];
export default BddElements;
